import { Box, TextField } from "@mui/material";
import ErrorWarningIcon from "components/common/InputErrorWarningIcon";
import { formatPhoneFaxNumber } from "helpers";
import { Controller, useFormContext } from "react-hook-form";

function ContactInfoForm() {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const getError = (fieldName: string): { message?: string } | undefined => {
    return errors[fieldName] as { message?: string } | undefined;
  };

  const errorIcon = (fieldName: string) => {
    const error = getError(fieldName);
    const isError = !!error;
    return {
      endAdornment: <ErrorWarningIcon hasError={isError} />,
    };
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Controller
        name="emailAddress"
        control={control}
        render={({ field }) => (
          <TextField
            label="Email Address"
            variant="outlined"
            className="w-full"
            type="email"
            error={!!getError("emailAddress")}
            helperText={
              (getError("emailAddress") as { message?: string })?.message
            }
            slotProps={{
              input: errorIcon("emailAddress"),
              htmlInput: {
                maxLength: 255,
              },
            }}
            {...field}
          />
        )}
      />

      <Controller
        name="primaryPhoneNumber"
        control={control}
        render={({ field }) => (
          <TextField
            label="Primary Phone Number"
            variant="outlined"
            className="w-full"
            error={!!getError("primaryPhoneNumber")}
            helperText={
              (getError("primaryPhoneNumber") as { message?: string })?.message
            }
            slotProps={{
              input: errorIcon("primaryPhoneNumber"),
              htmlInput: {
                maxLength: 12,
                inputMode: "numeric",
                pattern: "[0-9-]*",
              },
            }}
            onChange={(e) => {
              const formattedValue = formatPhoneFaxNumber(e.target.value);
              const numbersOnly = formattedValue.replace(/\D/g, "");
              field.onChange(numbersOnly);
            }}
            value={formatPhoneFaxNumber(field.value || "")}
          />
        )}
      />

      <Controller
        name="faxNumber"
        control={control}
        render={({ field }) => (
          <TextField
            label="Fax Number (optional)"
            variant="outlined"
            className="w-full"
            error={!!getError("faxNumber")}
            helperText={
              (getError("faxNumber") as { message?: string })?.message
            }
            slotProps={{
              input: errorIcon("faxNumber"),
              htmlInput: {
                maxLength: 12,
                inputMode: "numeric",
                pattern: "[0-9-]*",
              },
            }}
            onChange={(e) => {
              const formattedValue = formatPhoneFaxNumber(e.target.value);
              const numbersOnly = formattedValue.replace(/\D/g, "");
              field.onChange(numbersOnly);
            }}
            value={formatPhoneFaxNumber(field.value || "")}
          />
        )}
      />
    </Box>
  );
}

export default ContactInfoForm;
